import { render, staticRenderFns } from "./USDT.vue?vue&type=template&id=a7987be4&scoped=true"
import script from "./USDT.vue?vue&type=script&lang=js"
export * from "./USDT.vue?vue&type=script&lang=js"
import style0 from "./USDT.vue?vue&type=style&index=0&id=a7987be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7987be4",
  null
  
)

export default component.exports